import appTopups from "../../views/appSettings/topups.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "topups";
  const params = ["page", "limit", "topper", "user", "date"];

  $stateProvider.state("topups", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appTopups,
      },
    },
    reloadOnSearch: false,
    data: { title: "Topups" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/topups/topups.urls.js